import React from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeProvider from "../jsx/stripeProvider";
import ScrollToTop from "../jsx/layouts/ScrollToTop";
import AppShell from "./components/AppShell";

/* modern pages */
import Dashboard from "./pages/Dashboard";
import JobSearch from "./pages/JobSearch";
import JobDetail from "./pages/JobDetail";
import Profile from "./pages/Profile";
import Subscription from "./pages/Subscription";
import InterviewPrep from "./pages/InterviewPrep";
import AspireQuest from "./pages/AspireQuest";
import MockInterview from "./pages/MockInterview";
import ResumeUpload from "./pages/ResumeUpload";
import JobMatch from "./pages/JobMatch";
import CareerJourney from "./pages/CareerJourney";
import Outreach from "./pages/Outreach";

/* modern exam runner + video interview (ported from legacy Dashboard/Interview) */
import InterviewExam from "./pages/InterviewExam";
import InterviewVideo from "./pages/InterviewVideo";

/* legacy functional surfaces kept as-is (full-screen, template styling) */
import CheckOutPage from "../jsx/components/Dashboard/Home/checkOutPage";

const stripePromise = loadStripe(
  "pk_live_51Q9pepP9YE5TMcZPcE3MSMauCQCy2CjCgRVEtKazyCDmC5FDxYIicB2iZk8lpi0NRff1SoVOgbjHgrjzA1xWGT3e00KOiECVOW"
);

function ShellLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export default function Markup() {
  return (
    <StripeProvider>
      <Elements stripe={stripePromise}>
        <Routes>
          {/* full-screen surfaces without shell chrome */}
          <Route path="/interview-exam" element={<InterviewExam />} />
          <Route path="/videoInterview" element={<InterviewVideo />} />
          <Route path="/checkout" element={<CheckOutPage />} />

          {/* modern app inside the shell */}
          <Route element={<ShellLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/search-job" element={<JobSearch />} />
            <Route path="/job/detailed" element={<JobDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/interview-prep" element={<InterviewPrep />} />
            <Route path="/aspire-quest" element={<AspireQuest />} />
            <Route path="/recording" element={<MockInterview />} />
            <Route path="/resume-upload" element={<ResumeUpload />} />
            <Route path="/job-match" element={<JobMatch />} />
            <Route path="/career-journey" element={<CareerJourney />} />
            <Route path="/outreach" element={<Outreach />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
        <ScrollToTop />
      </Elements>
    </StripeProvider>
  );
}
